export default {
    state: {
        cards: []
    },
    namespaced: true,
    mutations: {
        add: (state, card) => {
            const index = state.cards.findIndex(c => c.key === card.key);
            if (index < 0) {
                const temp = [...state.cards];
                temp.push(card)
                state.cards = temp;
            } else {
                const temp = [...state.cards];
                temp[index].minimized = false;
                state.cards = [...temp];
            }
        },
        remove: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp.splice(index, 1);
                state.cards = [...temp];
            }
        },
        minimize: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp[index].minimized = true;
                state.cards = [...temp];
            }
        },
        maximize: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp[index].minimized = false;
                state.cards = [...temp];
            }
        },
        setActive: (state, key) => {
            const index = state.cards.findIndex(c => c.key === key);
            if (index > -1) {
                const temp = [...state.cards];
                temp[index].isActive = true;
                state.cards = [...temp];

                state.cards.forEach(card => {
                    if (card.type === "chatMessages" && card.key !== key) {
                        card.isActive = false;
                    }
                });
            }
        }
    },
    actions: {
        ADD: ({commit}, card) => {
            commit('add', card);
        },
        REMOVE: ({commit}, key) => {
            commit('remove', key);
        },
        MINIMIZE: ({commit}, key) => {
            commit('minimize', key);
        },
        MAXIMIZE: ({commit}, key) => {
            commit('maximize', key);
        },
        SET_ACTIVE: ({commit}, payload) => {   // New action
            commit('setActive', payload);
        },
    },
    getters: {
        chatCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'chat')
        },
        chatMessagesCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'chatMessages')
        },
        offerCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'offer')
        },
        advertiserCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'advertiser')
        },
        offerAggregatedLPCard: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'offerAggregatedLPCard')
        },
        lidCard: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'lid')
        },
        affiliateCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'affiliate')
        },
        campaignCards: (state) => {
            return state.cards.filter(c => c.minimized && c.type === 'campaign')
        },
        maximizedCards: (state) => {
            return state.cards.filter(c => c.minimized === false)
        },
        getCards: (state) => {
            return state.cards
        }
    }
};
